import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedeemOffersService } from './redeem-offers/redeem-offers.service';
import { TargetedOffersService } from './targeted-offers/targeted-offers.service';
import { TargetedOffersConfigService, TargetedOffersModule } from '@rogers/self-serve-targeted-offers';
import { ApiEndpointConfigService, ApiEndpointService } from '@rci/self-serve-shared';
import { TargetedOffersConfigServiceFactory } from './targeted-offers-config-service-factory';

@NgModule({
  imports: [CommonModule, TargetedOffersModule],
  providers: [
    {
      provide: TargetedOffersConfigService,
      useClass: TargetedOffersConfigServiceFactory,
      deps: [ApiEndpointService, ApiEndpointConfigService],
    },
    RedeemOffersService,
    TargetedOffersService,
  ],
})
export class BuyflowModule {}
